import React, { useMemo } from 'react'
import Countries from './Countries'
import ReactSelect from './ReactSelect'

export default function CountrySelect({ error, isClearable, name, handleBlur, value, disabled, onChange, placeholder = 'Select a country' }) {

  const countryOptions = useMemo(() => Countries.map(country => ({ label: country.name, value: country.code })), [])

  return (
    <ReactSelect
      error={error}
      isClearable={isClearable}
      name={name}
      onChange={onChange}
      onBlur={handleBlur}
      value={value}
      options={countryOptions}
      disabled={disabled}
      placeholder={placeholder}
    />
  )
}